import { render, staticRenderFns } from "./RgPlaybackController.vue?vue&type=template&id=227795c2&scoped=true"
import script from "./RgPlaybackController.vue?vue&type=script&lang=js"
export * from "./RgPlaybackController.vue?vue&type=script&lang=js"
import style0 from "./RgPlaybackController.vue?vue&type=style&index=0&id=227795c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227795c2",
  null
  
)

export default component.exports